<h4>Add statement of account</h4>
<form
	#addForm="ngForm"
	(ngSubmit)="add(addForm)"
	class="flex flex-col mt-5 items-end"
>
	<app-container type="dark" class="mb-4 flex-1 w-full">
		<app-input
			label="Description"
			[(ngModel)]="description"
			[submitted]="submitted"
			[required]="true"
			name="description"
			class="flex-1 w-full"
		></app-input>
		<app-input
			type="cents"
			[startIcon]="ICON.DOLLAR"
			label="Price"
			class="mt-3 mb-5"
			[(ngModel)]="price"
			[submitted]="submitted"
			[required]="true"
			name="price"
			class="flex-1 w-full mt-4 mb-5"
		></app-input>
	</app-container>
	<app-button type="submit">Add</app-button>
</form>
